import { WhatsNewLastSeenRequest, WhatsNewLastSeenResponse } from '@src/dtos/user-info.dto';
import axiosService from './axios-service';

class UserInfoService {
  /**
   * Fetches the last-seen date for What's New entries from the backend.
   * Returns { lastSeenDate: null } if the user has never seen the What's New tab.
   */
  public getWhatsNewLastSeen = async (): Promise<WhatsNewLastSeenResponse> => {
    const res = await axiosService.get('/api/customers/userInfo/whatsNewLastSeen');
    return res?.data;
  };

  /**
   * Records the current timestamp as the user's last-seen date for What's New.
   * Errors are propagated to the caller (the store handles degradation).
   */
  public updateWhatsNewLastSeen = async (body: WhatsNewLastSeenRequest): Promise<void> => {
    await axiosService.post('/api/customers/userInfo/whatsNewLastSeen', body);
  };
}

const userInfoService = new UserInfoService();
export default userInfoService;
